import { VALIDATION_MESSAGES } from '@/constants/validation';
import type { LocationAllowed } from '@/types';
import { array, mixed, object, string } from 'yup';
import type { ProgramFormData } from './programs.types';

export const programSchema = object({
	name: string().trim().required(VALIDATION_MESSAGES.required),
	description: string().trim(),
	expenseCodeType: string()
		.oneOf(['none', 'required'])
		.required(VALIDATION_MESSAGES.required),
	locationType: string()
		.oneOf(['any', 'limited'])
		.required(VALIDATION_MESSAGES.required),
	locationAllowed: mixed<LocationAllowed>()
		.oneOf([
			'between-permitted-locations',
			'from-permitted-locations',
			'to-or-from-permitted-locations',
		])
		.optional(),
	timeType: string()
		.oneOf(['all-day', 'weekdays', 'custom'])
		.required(VALIDATION_MESSAGES.required),
	startTime: string(),
	endTime: string(),
	days: array()
		.of(
			string().oneOf([
				'monday',
				'tuesday',
				'wednesday',
				'thursday',
				'friday',
				'saturday',
				'sunday',
			]),
		)
		.min(1, VALIDATION_MESSAGES.at_least_one),
	rideType: string()
		.oneOf(['all', 'limited'])
		.required(VALIDATION_MESSAGES.required),
	rides: array()
		.of(string().oneOf(['motorcycle', 'sedan', 'suv', 'delivery']))
		.min(1, VALIDATION_MESSAGES.at_least_one),
});

export const programInitialValues: ProgramFormData = {
	name: '',
	description: '',
	expenseCodeType: 'none',
	expenseCodes: undefined,
	locationType: 'any',
	locationAllowed: undefined,
	locations: [],
	timeType: 'all-day',
	startTime: '',
	endTime: '',
	days: [],
	rideType: 'all',
	rides: [],
};
